import { Divider, Stack, Typography } from '@mui/material'
import { QcSeriesDescription, QcSubmissionRange, QcTaskState } from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'
import StudyExamDetailPopupMenuList from '../exam/StudyExamDetailPopupMenuList'

// Format instance number range for display
function formatInstanceNumberRange(range: QcSubmissionRange): string | null {
  if (range.start === null || range.end === null) {
    return null
  }
  const displayEnd = range.end - 1

  // If start equals displayEnd, it's a single number
  if (range.start === displayEnd) {
    return `${range.start}`
  }

  // Otherwise it's a range
  return `${range.start}-${displayEnd}`
}

// Format the series label name with index suffix if it exists
function formatSeriesLabelName(name: string | null | undefined, index: number | null): string {
  if (!name) return ''
  if (index === null) return name
  return `${name}_${index.toString().padStart(2, '0')}`
}

export default function SeriesDefinitionInstance({
  seriesDescription,
  studyDescription,
  qcStatus,
  order,
}: {
  seriesDescription: QcSeriesDescription
  studyDescription: string
  qcStatus: string
  order: number
}) {
  return (
    <Stack
      direction="row"
      spacing={SPACING.spacingLg}
      alignItems="center"
      justifyContent="space-between"
      paddingX={SPACING.spacingLg}
      paddingY={SPACING.minSpacing}
    >
      <Stack spacing={SPACING.spacingXs}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Source series description
        </Typography>
        <Typography variant="body2">{seriesDescription.source_series_description.series_description}</Typography>
      </Stack>
      <Stack spacing={SPACING.spacingXs}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          New series description
        </Typography>
        <Typography variant="body2">
          {formatSeriesLabelName(seriesDescription.series_label_name, seriesDescription.series_label_index)}
        </Typography>
      </Stack>
      <Stack spacing={SPACING.spacingXs}>
        <Typography
          sx={{
            color: 'text.secondary',
          }}
          variant="subtitle2"
        >
          Images
        </Typography>
        {seriesDescription.instance_number_ranges.map((instanceNumberRange, key) => (
          <Typography variant="body2" key={key}>
            {formatInstanceNumberRange(instanceNumberRange)}
          </Typography>
        ))}
      </Stack>
      <Stack direction="row" spacing={SPACING.minSpacing} alignItems="center">
        <Divider orientation="vertical" flexItem />
        <StudyExamDetailPopupMenuList
          studyDescription={studyDescription}
          timepointSubmissionId={''}
          showViewerOption={false}
          qcTaskStatus={qcStatus as QcTaskState}
          qcTaskOrder={order}
          seriesDescription={seriesDescription}
        />
      </Stack>
    </Stack>
  )
}
